import { Heading, PageContainer, VStack } from '@/components/Atoms'
import { useMe } from '@/hooks/queries/useMe'
import { getUserGivenName } from '@repo/utils'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/_modules/credit/welcome/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: me } = useMe()
  const { t } = useTranslation('welcome')

  const messageForTimeOfDay = (() => {
    const hour = new Date().getHours()
    if (hour < 12) return 'credit.greetings.morning'
    if (hour < 18) return 'credit.greetings.afternoon'
    return 'credit.greetings.evening'
  })()

  const greetingMessage = me
    ? t(messageForTimeOfDay, { name: getUserGivenName(me) })
    : t('credit.greetings.welcome')

  return (
    <PageContainer maxWidth="wide">
      <VStack gap="md" className="py-6">
        <Heading level={1} className="text-5xl font-medium">
          {greetingMessage}
        </Heading>
        <Heading level={4} tone="muted" className="max-w-[700px] text-balance font-normal">
          {t('credit.greetings.description')}
        </Heading>
      </VStack>
    </PageContainer>
  )
}
